// extracted by mini-css-extract-plugin
module.exports = {"container":"howitworks_container__2pJXK","content":"howitworks_content__1QvTl"};